import React from 'react';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../../../../labelling-v2/components/stage-scope/hooks';
import { ANNOTATION_TYPE, SAM_ANNOTATION_ACTIONS } from '../../../../constants';
import Polygon from '../../polygon/polygon';
const AutoDetectPolygonPreview = () => {
  const {
    currentFrameAnnotationUnderUserReviewAtom
  } = useStageAtoms();
  const annotationUnderUserReview = useAtomValue(currentFrameAnnotationUnderUserReviewAtom);
  const pendingEntries = Object.entries(annotationUnderUserReview).filter(([, annotation]) => annotation.type === SAM_ANNOTATION_ACTIONS.AUTO_DETECT_POLYGON);
  if (pendingEntries.length === 0) return null;
  return (
    // This renders outside the main stage <svg data-stage-svg="true">, as a sibling inside
    // StageActions alongside BoundingBoxActions' own per-annotation <svg> overlays. Those
    // sibling <svg>s aren't positioned, so without explicit absolute positioning here this
    // <svg> would be pushed down in normal block flow instead of overlaying the stage at (0,0).
    <svg width="100%" height="100%" style={{
      position: 'absolute',
      top: 0,
      left: 0
    }}>
      {pendingEntries.map(([annotationId, annotation]) => {
        if (annotation.type !== SAM_ANNOTATION_ACTIONS.AUTO_DETECT_POLYGON) return null;
        const polygonData = annotation.annotationData?.[0];
        const annotationLabel = annotation.annotationMetaData[0]?.annotationLabel;
        if (!polygonData?.points?.length || !annotationLabel) return null;
        return <Polygon key={annotationId} isDrawing={false} annotation={{
          annotationType: ANNOTATION_TYPE.POLYGON,
          data: polygonData,
          annotationLabel
        }} />;
      })}
    </svg>
  );
};
export default AutoDetectPolygonPreview;